<template>
  <div :class="['text', isPC && 'text-select']">
    {{ description }}
  </div>
</template>

<script lang="ts">
import { customerServicePayloadType } from '../../../../../../interface';
import { isPC } from '../../../../../../utils/env';

interface Props {
  payload: customerServicePayloadType;
}

export default {
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    return {
      description: props.payload.description,
      isPC,
    };
  },
};
</script>
<style lang="scss" scoped>
.text-select {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.text {
  white-space: pre-wrap;
  font-size: 14px;
  text-size-adjust: none;
  overflow-wrap: break-word;
  word-break: normal;
}
</style>
